const backendUrl = "https://shikshakprabandan.herokuapp.com/";

module.exports = {
    backendUrl,
};